import React, { useState, useEffect, useRef } from 'react';
import HTMLFlipBook from 'react-pageflip';
import './libro.css';
import { getInformacionG, getImagenes } from '../../services/perfiles/perfiles';
import { Button, message } from 'antd';
import InfoPoblacion from './infoPoblacion';
import TablaPiramideP from './componentes/tablaPiramideP';
import PoblationTD from './componentes/tablaPoblaciond';
import PiramideP from './componentes/piramideP';
import GeneroTabla from './componentes/generoTabla';
import EtniasComponente from './componentes/etniasT.js';
import SisvenComponente from './componentes/sisvenComponente.js';
import ComponenteAmbiental from './componentes/ambientalComonenete.js';
import ServicioEcosistemaC from './componentes/servicioECompo.js';
import RedVialC from './componentes/red_vial.js';
import ResiduosC from './componentes/residuos.js';
import CategoriaVial from './componentes/categoriaVial.js';
import Actividadeconomica from './componentes/actividadeconomica.js';
import ServiciosPblicos from './componentes/serviciospublicos.js';
import ComponenetAgro from './componentes/agropecuarioC.js';
import { jsPDF } from "jspdf"; // Importamos jsPDF
import ComponentePecuario from './componentes/componentePecuario.js';
import SaludComponente from './componentes/saludCom.js';
import EducacionComponente from './componentes/educacionC.js';
import InversionCpmponente from './componentes/inversionC.js';
import IndiceComponente from './componentes/indiceDeseC.js';
import ParticipacionCiudadanaComponente from './componentes/participacioCiuC.js';
import TotalPoblacion from '../indicadorPerfil/TPoblacion.js';


const Perfiles = ({ municipioId, municipio }) => {
  const [data, setData] = useState(null);
  const [dataImgen, setdataImgen] = useState(null);
  const [error, setError] = useState('');
  const [portadaUrl, setPortadaUrl] = useState('');
  const [BseUrl, setBseUrl] = useState('');
  const baseUrl = 'https://tangara.gov.co'; // Define tu URL base aquí
  const imganeMineria = dataImgen?.INFORMACION_GEOGRAFICA_MUNICIPIO?.Mapa_mineria || null;
  const imganevial = dataImgen?.INFORMACION_GEOGRAFICA_MUNICIPIO?.Mapa_vial || null;
  const flipbookRef = useRef(null);
  let year = new Date().getFullYear();


  useEffect(() => {
    if (municipioId) {
      fetchIndicadores();
      getImG();
    }
  }, [municipioId]);

  const fetchIndicadores = async () => {
    setError('');
    try {
      const response = await getInformacionG(municipioId);
      if (response && response.status === 200) {
        const fetchedData = response.data;
        setPortadaUrl(`https://tangara.gov.co/_lib/file/doc/perfiles/portada/${fetchedData.RESEÑA_HISTÓRICA.portada}`);
        setBseUrl(`https://tangara.gov.co/`)
        setData(fetchedData);
      } else {
        throw new Error('Invalid response from server');
      }

    } catch (error) {
      setError('Error loading data');
      message.success('Escoja un municipio');

    }
  };
  const getImG = async () => {
    setError('');
    try {
      const response = await getImagenes(municipioId);
      if (response.status === 200 && response.data) {
        const fetchedData = response.data;
        // Verificamos si `descripciones` existe y es un array
        if (Array.isArray(fetchedData)) {
          const basePath = `${baseUrl}/_lib/file/doc/perfiles/`;

          const mapUrls = fetchedData.map(item => {
            switch (item.descripcion) {
              case 'politico':
                return { tipo: 'Mapa_politico', url: `${basePath}mapas_politicos/mpolitico${municipioId}.jpg` };
              case 'mineria':
                return { tipo: 'Mapa_mineria', url: `${basePath}mapas_mineros/mineria${municipioId}.jpg` };
              case 'mvial':
                return { tipo: 'Mapa_vial', url: `${basePath}mapas_viales/mvial${municipioId}.jpg` };
              case 'ban':
                return { tipo: 'Mapa_ban', url: `${basePath}mapas_ban/ban${municipioId}.jpg` };
              case 'esc':
                return { tipo: 'Mapa_esc', url: `${basePath}mapas_esc/esc${municipioId}.jpg` };
              default:
                return null;
            }
          }).filter(item => item !== null);

          const mapas = mapUrls.reduce((acc, curr) => {
            acc[curr.tipo] = curr.url;
            return acc;
          }, {});

          setdataImgen({
            INFORMACION_GEOGRAFICA_MUNICIPIO: mapas,
          });
        } else {
          throw new Error('descripciones is not an array or is undefined');
        }
      } else {
        throw new Error('Invalid response from server');
      }
    } catch (error) {
      console.error('Error fetching images:', error);
      setError('Error loading data');
    }
  };

  const generatePDF = () => {
    const doc = new jsPDF();

    // Aquí puedes agregar contenido al PDF. Por ejemplo, podrías capturar el contenido del componente Perfiles
    doc.text("Perfiles Municipio", 20, 20); // Título del PDF

    // Si Perfiles es un componente visual, puedes capturar su HTML
    const perfilesElement = document.getElementById("perfiles-content"); // Asegúrate de darle un id al contenedor de Perfiles
    doc.html(perfilesElement, {
      callback: function (doc) {
        doc.save('perfiles.pdf'); // Guarda el PDF
      },
      x: 10,
      y: 30
    });
  };

  return (
    <div id="perfiles-content"> <Button >Generar PDF</Button>
      {error && <p style={{ color: 'red' }}>{error}</p>}
      <HTMLFlipBook ref={flipbookRef} width={1140} height={1250} className="my-flip-book">

        {/* Portada */}
        <div className="hard front-side cover" style={{ backgroundImage: `url(${portadaUrl})` }}>
          {portadaUrl && <img src={portadaUrl} alt="Cover" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />}
          {data && data.RESEÑA_HISTÓRICA["Nombre_Municipio"] && (
            <h2 style={{ position: 'absolute', top: '15px', left: '15px', color: 'white', zIndex: 1 }}>
              {data.RESEÑA_HISTÓRICA["Nombre_Municipio"]}
            </h2>
          )}
        </div>

        {/* Primera Hoja: Componente y Reseña Histórica */}
        <div className="page">
          <div className="page-content">
            {data && (
              <div>
                <h2>
                  {data.RESEÑA_HISTÓRICA["Nombre_Municipio"]}
                </h2>
              </div>
            )}
            <div className="container bg-map-fill">
              <div className="row pt-5">
                {data && (
                  <div className="col">
                    <p><strong>PERFIL DEL MUNICIPIO DE  {data.RESEÑA_HISTÓRICA["Nombre_Municipio"]}</strong></p>
                    <p><strong>GOBERNACIÓN DEL CAUCA</strong><br />
                      Dr. Jorge Octavio Guzmán Gutiérrez<br />
                      Gobernador del departamento del Cauca</p>
                    <p><strong>OFICINA ASESORA DE PLANEACIÓN</strong><br />
                      Dra. Diana Melissa Muriel Muñoz<br />
                      Jefe Oficina Asesora de Planeación</p>
                    <p><strong>ALCALDÍA DE  {data.RESEÑA_HISTÓRICA["Nombre_Municipio"]} </strong><br />
                      {data.RESEÑA_HISTÓRICA["NombreAlcalde"]}<br />
                      Alcalde Municipal<br />
                      {data.RESEÑA_HISTÓRICA["periodo"]}</p>
                    <p><strong>PERFIL DEL MUNICIPIO DE {data.RESEÑA_HISTÓRICA["Nombre_Municipio"]}  {year}</strong></p>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
        {/* Primera Hoja: Componente y Reseña Histórica */}
        <div className="page">

          <div className="page-content">
            <h1>{data ? data.componete.Nombre_Componente : 'Cargando...'}</h1>
            {data && (
              <div>
                <p><strong>Texto histórico:</strong></p>
                <div style={{ columnCount: 2, columnGap: '30px' }} dangerouslySetInnerHTML={{ __html: data.RESEÑA_HISTÓRICA["Texto histórico"] }} />
              </div>
            )}
          </div>
        </div>
        <div className="page">
          <div className="page-content">
            <h1>Símbolos Patrios</h1>
            {data && (
              <div>
                <div className="bandera-container">
                  <p><strong>Himno:</strong></p>
                  <div dangerouslySetInnerHTML={{ __html: data.SIMBOLOS_PATRIOS.Himno }} />
                </div>
                <div className="row row-cols-md-2">
                  <div className="col-sm-12 col-lg-6 escudo-container">
                    <img src={`${BseUrl}${data.SIMBOLOS_PATRIOS.Escudo.URL}`} className="escudo-image" alt='' />
                    <div className="escudo-description" dangerouslySetInnerHTML={{ __html: data.SIMBOLOS_PATRIOS.Escudo.Descripción }} />
                    <p><strong>Fuente de Información:</strong> {data.SIMBOLOS_PATRIOS.Fuente}</p>
                  </div>

                  <div className="col-sm-12 col-lg-6 bandera-container">
                    <img src={`${BseUrl}${data.SIMBOLOS_PATRIOS.Bandera.URL}`} className="bandera-image" alt='' />
                    <div className="bandera-description" dangerouslySetInnerHTML={{ __html: data.SIMBOLOS_PATRIOS.Bandera.Descripción }} />
                    <p><strong>Fuente de Información:</strong> {data.SIMBOLOS_PATRIOS.Bandera.Fuente}</p>
                  </div>
                </div>

              </div>
            )}
          </div>
        </div>
        <div className="page">
          <div className="page-content">
            <h1>Información Geográfica del Municipio</h1>
            <div>
              {dataImgen && dataImgen.INFORMACION_GEOGRAFICA_MUNICIPIO && (
                <>
                  <div className="mapa_politico">
                    {dataImgen.INFORMACION_GEOGRAFICA_MUNICIPIO.Mapa_politico && (
                      <img className="mapa_politicoimg" src={dataImgen.INFORMACION_GEOGRAFICA_MUNICIPIO.Mapa_politico} alt="Mapa político" />
                    )}
                  </div>
                </>
              )}
            </div>
            {data && (
              <div>
                <p><strong>Subregión:</strong> {data.INFORMACION_GEOGRAFICA_MUNICIPIO.Subregion}</p>
                <p><strong>Extensión Total:</strong> {data.INFORMACION_GEOGRAFICA_MUNICIPIO.Extension_total} km²</p>
                <p><strong>Extensión Urbana:</strong> {data.INFORMACION_GEOGRAFICA_MUNICIPIO.Extension_urbana} km²</p>
                <p><strong>Extensión Rural:</strong> {data.INFORMACION_GEOGRAFICA_MUNICIPIO.Extension_rural} km²</p>
                <p><strong>Extensión Centro Poblado:</strong> {data.INFORMACION_GEOGRAFICA_MUNICIPIO.Extension_centro_poblado} km²</p>
                <p><strong>Temperatura Media:</strong> {data.INFORMACION_GEOGRAFICA_MUNICIPIO.Temperatura_media} °C</p>
              </div>
            )}
            <TotalPoblacion municipio={municipio} />
          </div>

        </div>
        <div className="page">
          <InfoPoblacion municipioId={municipioId} />
          <TablaPiramideP municipioId={municipioId} />
          <PoblationTD municipioId={municipioId} />
        </div>
        <div className="page">
          <PiramideP municipioId={municipioId} />
          <GeneroTabla municipioId={municipioId} />
        </div>
        <div className="page">
          <div className="page-content">
            <EtniasComponente municipioId={municipioId} />
            <SisvenComponente municipioId={municipioId} /></div>
        </div>
        <div className="page">
          <h1>2. COMPONENTE AMBIENTAL </h1>
          <ComponenteAmbiental municipioId={municipioId} />
        </div>
        <div className="page">
          <ServicioEcosistemaC municipioId={municipioId} imganeMineria={imganeMineria} />
        </div>
        <div className="page">
          <ResiduosC municipioId={municipioId} />
        </div>
        <div className="page">
          <RedVialC municipioId={municipioId} imganevial={imganevial} />
        </div>
        <div className="page">
          <CategoriaVial municipioId={municipioId} imganevial={imganevial} />
        </div>
        <div className="page">
          <h1>4. COMPONENTE ECONÓMICO</h1>
          <Actividadeconomica municipioId={municipioId} />
        </div>
        <div className="page">
          <ServiciosPblicos municipioId={municipioId} />
        </div>
        <div className="page">
          <ComponenetAgro municipioId={municipioId} />
        </div>
        <div className="page">
          <ComponentePecuario municipioId={municipioId} />
        </div>
        <div className="page">
          <SaludComponente municipioId={municipioId} />
        </div>
        <div className="page">
          <EducacionComponente municipioId={municipioId} />
        </div>
        <div className="page">
          <div className="page-content">
            <InversionCpmponente municipioId={municipioId} />
            <IndiceComponente municipioId={municipioId} />
          </div>
        </div>
        <div className="page">
          <ParticipacionCiudadanaComponente municipioId={municipioId} />
        </div>
      </HTMLFlipBook>
    </div>
  );
}
export default Perfiles;
{/* {dataImgen.INFORMACION_GEOGRAFICA_MUNICIPIO.Mapa_mineria && (
              <img src={dataImgen.INFORMACION_GEOGRAFICA_MUNICIPIO.Mapa_mineria} alt="Mapa minería" />
            )}
            {dataImgen.INFORMACION_GEOGRAFICA_MUNICIPIO.Mapa_vial && (
              <img src={dataImgen.INFORMACION_GEOGRAFICA_MUNICIPIO.Mapa_vial} alt="Mapa vial" />
            )}
            {dataImgen.INFORMACION_GEOGRAFICA_MUNICIPIO.Mapa_ban && (
              <img src={dataImgen.INFORMACION_GEOGRAFICA_MUNICIPIO.Mapa_ban} alt="Mapa ban" />
            )}
            {dataImgen.INFORMACION_GEOGRAFICA_MUNICIPIO.Mapa_esc && (
              <img src={dataImgen.INFORMACION_GEOGRAFICA_MUNICIPIO.Mapa_esc} alt="Mapa esc" />
            )} */}